import DOMPurify from 'dompurify';

/**
 * Sanitiza HTML para prevenir ataques XSS
 * Permite solo tags seguros para contenido enriquecido
 */
export const sanitizeHtml = (dirty: string): string => {
    return DOMPurify.sanitize(dirty, {
        ALLOWED_TAGS: [
            'p', 'br', 'strong', 'em', 'u', 'b', 'i',
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'ul', 'ol', 'li',
            'a', 'code', 'pre',
            'blockquote', 'hr',
            'span', 'div'
        ],
        ALLOWED_ATTR: ['href', 'class', 'target', 'rel']
    });
};
